/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import { Dropdown, ButtonGroup, Spinner } from 'react-bootstrap';
import MobileMenu from './MobileMenu';
import MenuIcon from '@mui/icons-material/Menu';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import toast from 'react-hot-toast';
import { renderTrialMessage } from './header';
import { routers } from 'router/router';
import { useHistory } from 'react-router';
import { useAppDispatch, useAppSelector } from 'app/hooks';
import {
  getCurrentBasicDetail,
  getStripeSubscription,
  getStripeSubscriptionInfo,
  logout,
} from 'app/basicInformationSlice/basicInformationSlice';
import { useLocation } from 'react-router-dom';
import { authenticateSettings } from 'components/helper/appConfig';
import PaymentServices from 'services/payment';
import basicInformationServices from 'services/basicInformationApi';
import { getUserId, getAccessToken, removeAccessToken, removeUserId } from 'utils/sessionStorage';
import { STRIPE_PRICE_NAME, USER_ROLE } from 'constants/common';
import SettingsIcon from '@mui/icons-material/Settings';
import LogoutOutlinedIcon from '@mui/icons-material/LogoutOutlined';

interface Props {}
const MobileHeader = (props: Props) => {
  let location = useLocation();
  let history = useHistory();
  const dispatch:any = useAppDispatch();
  const [stripeSubscription, setStripeSubscription] = React.useState<any>(null);
  const [subscriptionInfo, setSubscriptionInfo] = React.useState<any>(null);
  const [studentStripeSubscription, setStudentStripeSubscription] = React.useState<any>(null);
  const [studentSubscriptionInfo, setStudentSubscriptionInfo] = React.useState<any>(null);  
  const personalStore = useAppSelector((store) => store.basicInformation.myBasicInformation);
  const currentStudentId = useAppSelector((store) => store.basicInformation.currentStudentId);
  const myStripeSubscription = useAppSelector((store) => store.basicInformation.myStripeSubscription);
  const stripeSubscriptionInfo = useAppSelector((store) => store.basicInformation.stripeSubscriptionInfo);
  const fakeStudentId = `25${personalStore?.student_id ?? '00'}`;
  const role = personalStore?.user_role ?? (sessionStorage.getItem('userRole') || '');

  const handleLogout = () => {
    try {
      dispatch(logout());
      toast.success('You have been successfully logged out!');
      removeAccessToken();
      removeUserId();
      history.push(routers.login.path);
    }
    catch(ex){
      //skip
    }
  };

  // Removed handleSilenLogout - backend will handle invalid tokens
      
  const getPlanName = (ret: any) => {
    if (ret && ret.subcription_plan) {
        switch (ret.subcription_plan) {
          case STRIPE_PRICE_NAME.GradMapStarter:
          return 'GradMap Starter';
          case STRIPE_PRICE_NAME.SilverMonth:
          return 'Silver Month';
          case STRIPE_PRICE_NAME.SilverYear:
          return 'Silver Month';
          case STRIPE_PRICE_NAME.GoldMonth:
          return 'Gold Month';
          case STRIPE_PRICE_NAME.GoldYear:
          return 'Gold Year';
          case STRIPE_PRICE_NAME.SilverPlusMonth:
          return 'Silver Plus Month';
          case STRIPE_PRICE_NAME.SilverPlusYear:
          return 'Silver Plus Month';
          default:
            return ''; //not applicable, not available
        }
    }
    return '';
  };

  async function getUserBillPortalUrl() {
    let returnUrl = `${window.location.origin}/#/settings?active-tab=5`;       
    let billUrl: any = await PaymentServices.getUserBillPortalUrl(
      returnUrl,
      personalStore.student_id
    );
    return billUrl;
  }

  async function getStudentBillPortalUrl(studentId: any) {
    if (!Number.isNaN(studentId)) {
      let returnUrl = `${window.location.origin}/#/application/counselor/${studentId}`;       
      let billUrl: any = await PaymentServices.getUserBillPortalUrl(returnUrl, studentId);
      return billUrl;
    }
    else{
      return '';
    }
  }

  const onClickUpgradeLink = async () => {
    let billUrl: any = await getUserBillPortalUrl();
    if (billUrl) {
      window.location.href = `${billUrl}`;
    }
  };


  const onClickStudentUpgradeLink = async() => {
    let studentId = currentStudentId || getUserId();
    let token = getAccessToken();
    if (studentId && token) {
      try {
        let billUrl:any = await getStudentBillPortalUrl(studentId);
        if (billUrl) {
          window.location.href = `${billUrl}`;
        }
      } catch (ex) {
        // Backend will handle invalid tokens
        console.error('Error getting bill URL:', ex);
      }
    }
    // If no token/userId, just skip - backend will handle authentication
  } 

  // Sync từ Redux store khi có data
  React.useEffect(() => {
    if (myStripeSubscription) {
      setStripeSubscription(myStripeSubscription);
    }
  }, [myStripeSubscription]);

  React.useEffect(() => {
    if (stripeSubscriptionInfo) {
      setSubscriptionInfo(stripeSubscriptionInfo);
    }
  }, [stripeSubscriptionInfo]);

  // Chỉ gọi API khi component mount và chưa có data trong Redux store
  React.useEffect(() => {
    const getData = async () => {
      let id = getUserId();
      let token = getAccessToken();
      if (token && id && personalStore?.student_id) {
        // Chỉ gọi nếu chưa có data trong Redux store
        if (!myStripeSubscription || !stripeSubscriptionInfo) {
          try {
            if (!myStripeSubscription) {
              let ss: any = await dispatch(getStripeSubscription(id)).unwrap();
              setStripeSubscription(ss);
            }
            if (!stripeSubscriptionInfo) {
              let ssInfo = await dispatch(getStripeSubscriptionInfo(id)).unwrap();
              setSubscriptionInfo(ssInfo);
            }
          } catch (ex) {
            // Backend will handle invalid tokens, no need to auto logout
            console.error('Error loading subscription data:', ex);
          }
        }
      }
      // If no token/userId, just skip - backend will handle authentication
    };

    getData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [personalStore?.student_id]);

  const updateStudentInfo = async () => {
    if (role === USER_ROLE.parent && currentStudentId) {
      try {
        let ss:any=  await dispatch(getStripeSubscription(currentStudentId)).unwrap();
        setStudentStripeSubscription(ss);
        // Avoid writing child's Stripe status into global Redux (parent has no own subscription)
        const ssInfo = await basicInformationServices.getEnableExtention(currentStudentId);
        setStudentSubscriptionInfo(ssInfo);
      } catch (ex) {
        // Backend will handle invalid tokens, no need to auto logout
        console.error('Error updating student info:', ex);
      }
    }
  }

  // Chỉ gọi khi currentStudentId thay đổi, không phụ thuộc vào location
  React.useEffect(() => {
    if (role === USER_ROLE.parent && currentStudentId) {
      updateStudentInfo();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentStudentId, role]);
  

  return (
    <>
      <div className="gm-topbar mobile-header">
        <div className="d-flex align-items-center">
          <MobileMenu />
        </div>
       
        <div className="d-flex align-items-center">
          {personalStore?.user_role === USER_ROLE.student && (
            subscriptionInfo ? (
              <div className="user-info me-3">
                <span className="plan-text">Plan: {getPlanName(subscriptionInfo)}</span>
                {subscriptionInfo?.subcription_plan !== STRIPE_PRICE_NAME.GoldMonth &&
                  subscriptionInfo?.subcription_plan !== STRIPE_PRICE_NAME.GoldYear && (
                    <span
                      className="upgrade-link"
                      onClick={onClickUpgradeLink}
                      title="Upgrade Subscription Plan"
                    >
                      • Upgrade
                    </span>
                  )}
                <div className="gm-id">ID: {fakeStudentId}</div>
              </div>
            ) : (
              <div className="user-info me-3 d-inline-flex align-items-center" role="status" aria-live="polite" aria-busy="true">
                <Spinner animation="border" size="sm" className="me-1" />
                Checking plan...
              </div>
            )
          )}

          {personalStore?.user_role === USER_ROLE.parent
                     && window.location.hash.includes('#/application/counselor/') && currentStudentId && (
            studentStripeSubscription && studentSubscriptionInfo ? (
              <div className="user-info me-3">
                <span className="plan-text">Plan: {getPlanName(studentSubscriptionInfo)}</span>
                {studentSubscriptionInfo?.subcription_plan !== STRIPE_PRICE_NAME.GoldMonth &&
                 studentSubscriptionInfo?.subcription_plan !== STRIPE_PRICE_NAME.GoldYear && (
                    <span
                      className="upgrade-link"
                      onClick={onClickStudentUpgradeLink}
                      title="Upgrade Subscription Plan"
                    >
                      • Upgrade
                    </span>
                  )}
                <div className="gm-id">Student GM ID: 25{studentStripeSubscription?.student_id ?? '00'} </div>
              </div>
            ) : (
              <div className="user-info me-3 d-inline-flex align-items-center" role="status" aria-live="polite" aria-busy="true">
                <Spinner animation="border" size="sm" className="me-1" />
                Checking plan...
              </div>
            )
          )}

          <Dropdown as={ButtonGroup}>
            <Dropdown.Toggle variant="white" id="dropdown-split-basic" className="simple-avatar-toggle">
              <AccountCircleIcon className="avatar-icon" />
            </Dropdown.Toggle>

            <Dropdown.Menu className="simple-dropdown-menu">
              <div className="dropdown-user-info">
                <div className="user-name-display">{personalStore?.first_name} {personalStore?.last_name}</div>
                <div className="user-role-display">Student</div>
              </div>
              <Dropdown.Divider />
              <Dropdown.Item onClick={() => history.push(routers.settings.path)}>
                <SettingsIcon />
                &nbsp;
                Settings
              </Dropdown.Item>
              <Dropdown.Item onClick={() => handleLogout()}>
                <LogoutOutlinedIcon />
                &nbsp;
                Logout
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </div>
      </div>
    <div className="d-flex w-100 justify-content-center text-danger">
        {personalStore?.user_role === USER_ROLE.student && stripeSubscription && stripeSubscription?.status === 'trialing' && (
          <div
            className="d-flex text-danger text-center pl-3 align-self-center "
            style={{ margin: '8px' }}
          >
            {`${renderTrialMessage(stripeSubscription)}`}
            {!location.pathname.includes('/payment') && (
              <>
              &nbsp;<a href="/#/payment">Click here to subscribe!</a>
              </>
            )}
          </div>
        )}
    </div>
    <style scoped>{`
        .mobile-header {
          padding: 8px 16px;
          position: relative;
          z-index: 999;
        }

        .user-info {
          text-align: right;
          font-size: 12px;
        }

        .plan-text {
          color: #495057;
          font-weight: 500;
        }

        .upgrade-link {
          color: #007bff;
          cursor: pointer;
          text-decoration: underline;
          margin-left: 4px;
        }

        .upgrade-link:hover {
          color: #0056b3;
        }

        .gm-id {
          color: #6c757d;
          font-size: 11px;
          margin-top: 2px;
        }

        .simple-avatar-toggle {
          background: transparent !important;
          border: none !important;
          box-shadow: none !important;
          padding: 4px !important;
        }

        .avatar-icon {
          font-size: 32px !important;
          color: #6c757d;
        }

        .avatar-icon:hover {
          color: #495057;
        }

        .simple-dropdown-menu {
          border-radius: 8px !important;
          box-shadow: 0 4px 12px rgba(0,0,0,0.15) !important;
          border: 1px solid #dee2e6 !important;
          z-index: 9999 !important;
          min-width: 200px !important;
        }

        .dropdown-user-info {
          padding: 12px 16px;
          text-align: left;
        }

        .user-name-display {
          font-weight: 600;
          font-size: 14px;
          color: #212529;
          margin-bottom: 2px;
        }

        .user-role-display {
          font-size: 12px;
          color: #6c757d;
        }

        .dropdown-item {
          padding: 8px 16px !important;
          font-size: 14px !important;
        }

        .dropdown-item:hover {
          background-color: #f8f9fa !important;
        }

        /* Mobile responsive */
        @media (max-width: 576px) {
          .user-info {
            font-size: 11px;
          }
          
          .gm-id {
            font-size: 10px;
          }
        }
    `}</style>   
    </>
  );
};

export default MobileHeader;
